import { memo } from 'react';
import { useCampaignsPlatformEditAction } from './hooks/useCampaignsPlatformEditAction';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
function CampaignsPlatformEditAction({
  objectType,
  assetId,
  crmIdProperty = 'hs_object_id',
  use = 'secondary',
  children
}) {
  const {
    isDisabled,
    onCampaignEdit,
    editActionText
  } = useCampaignsPlatformEditAction({
    objectType,
    assetId,
    crmIdProperty
  });
  if (isDisabled) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, {
    onClick: onCampaignEdit,
    "data-test-id": "campaigns-platform-edit-action-button",
    use: use,
    children: children || editActionText
  });
}
export default /*#__PURE__*/memo(CampaignsPlatformEditAction);